'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

require('../_tslib-15827112.js');
var request = _interopDefault(require('axios'));
require('./Controllers/BaseController.js');
var ReimbursementsController = require('./Controllers/Reimbursements/ReimbursementsController.js');
var UserController = require('./Controllers/User/UserController.js');
var TicketsController = require('./Controllers/Tickets/TicketsController.js');
var ReimbursementTypesController = require('./Controllers/ReimbursementTypes/ReimbursementTypesController.js');
var BalanceController = require('./Controllers/Balance/BalanceController.js');
var LogoutController = require('./Controllers/Logout/LogoutController.js');
var ReferralsController = require('./Controllers/Referrals/ReferralsController.js');
var NotificationsController = require('./Controllers/Notifications/NotificationsController.js');
var OptController = require('./Controllers/Opt/OptController.js');
var CashbackRewardsController = require('./Controllers/CashbackRewards/CashbackRewardsController.js');
var PhoneController = require('./Controllers/Phone/PhoneController.js');

var AuthApiClient = /** @class */ (function () {
    function AuthApiClient(_a) {
        var countryCode = _a.countryCode, apiUrl = _a.apiUrl, getCookie = _a.getCookie;
        this.httpClient = request.create({
            baseURL: apiUrl + "_api/v1",
        });
        this.config = {
            countryCode: countryCode,
            getCookie: getCookie
        };
    }
    Object.defineProperty(AuthApiClient.prototype, "Reimbursements", {
        get: function () {
            return new ReimbursementsController.default(this.httpClient, this.config);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AuthApiClient.prototype, "ReimbursementTypes", {
        get: function () {
            return new ReimbursementTypesController.default(this.httpClient, this.config);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AuthApiClient.prototype, "User", {
        get: function () {
            return new UserController.default(this.httpClient, this.config);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AuthApiClient.prototype, "Tickets", {
        get: function () {
            return new TicketsController.default(this.httpClient, this.config);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AuthApiClient.prototype, "Balance", {
        get: function () {
            return new BalanceController.default(this.httpClient, this.config);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AuthApiClient.prototype, "Logout", {
        get: function () {
            return new LogoutController.default(this.httpClient, this.config);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AuthApiClient.prototype, "Referrals", {
        get: function () {
            return new ReferralsController.default(this.httpClient, this.config);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AuthApiClient.prototype, "Notifications", {
        get: function () {
            return new NotificationsController.default(this.httpClient, this.config);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AuthApiClient.prototype, "Opt", {
        get: function () {
            return new OptController.default(this.httpClient, this.config);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AuthApiClient.prototype, "CashbackRewards", {
        get: function () {
            return new CashbackRewardsController.default(this.httpClient, this.config);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AuthApiClient.prototype, "Phone", {
        get: function () {
            return new PhoneController.default(this.httpClient, this.config);
        },
        enumerable: false,
        configurable: true
    });
    AuthApiClient.prototype.isLogged = function () {
        return this.GetUserId() && this.GetAccessToken();
    };
    AuthApiClient.prototype.GetUserId = function () {
        return this.config.getCookie("EndUserId");
    };
    AuthApiClient.prototype.GetAccessToken = function () {
        return this.config.getCookie("AccessToken");
    };
    return AuthApiClient;
}());

exports.default = AuthApiClient;
//# sourceMappingURL=AuthApiClient.js.map
